import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { MuiColors } from '@/types/colors';

export const CustomStepConnector = (
  <StepConnector
    sx={{
      [`&.${stepConnectorClasses.vertical}`]: {
        marginLeft: '16px',
      },
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: MuiColors.secondaryColor,
      },
    }}
  />
);
